import moment from "moment-timezone";

import { DateValues, getDateRange } from "../../common/DateFiltersPicker";
import { getBerlinMomentTimezone } from "../../common/helpers";
import { DateInputType } from "../../common/TransactionFilters/DateInput";
import { SAVE_DATE_FORMAT } from "@/v1/constants";

export function getDefaultZmDateFilters(): DateValues & {
  defaultYear: string;
  defaultQuarter: string;
  defaultMonth: moment.Moment | null;
} {
  // "Today in Berlin" decides the default quarter, but the boundary itself is a
  // plain date so it compares like-for-like against the period ends.
  const now = getBerlinMomentTimezone();
  const maxDate = now.format(SAVE_DATE_FORMAT);
  const defaultYear = now.format("YYYY");
  const defaultQuarter = `Q${now.quarter()}`;
  const quarterLabel = `${defaultQuarter}.${defaultYear}`;
  const { dateFrom, dateTo } = getDateRange(
    quarterLabel,
    DateInputType.Quarter,
    maxDate
  );

  return {
    dateFrom,
    dateTo,
    defaultYear,
    defaultQuarter,
    defaultMonth: null,
  };
}
